import { createThunkEffect } from "../../utilities/ActionUtility";
import * as EmptyOrderFilesEffect from "./EmptyOrderFilesEffect";

export const REQUEST_EMPTY_ORDER_FILES = "EmptyOrderFilesEffect.REQUEST_EMPTY_ORDER_FILES";
export const REQUEST_EMPTY_ORDER_FILES_FINISHED = "EmptyOrderFilesEffect.REQUEST_EMPTY_ORDER_FILES_FINISHED";

export const ADD_EMPTY_ORDER_FILE = "EmptyOrderFilesEffect.ADD_EMPTY_ORDER_FILE";
export const ADD_EMPTY_ORDER_FILE_FINISHED = "EmptyOrderFilesEffect.ADD_EMPTY_ORDER_FILE_FINISHED";

export const GET_EMPTY_ORDER_FILES = "EmptyOrderFilesEffect.GET_EMPTY_ORDER_FILES";
export const GET_EMPTY_ORDER_FILES_FINISHED = "EmptyOrderFilesEffect.GET_EMPTY_ORDER_FILES_FINISHED";

export const REMOVE_EMPTY_ORDER_FILE = "EmptyOrderFilesEffect.REMOVE_EMPTY_ORDER_FILE";
export const REMOVE_EMPTY_ORDER_FILE_FINISHED = "EmptyOrderFilesEffect.REMOVE_EMPTY_ORDER_FILE_FINISHED";

export function getAllEmptyOrderFiles() {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_EMPTY_ORDER_FILES, EmptyOrderFilesEffect.getAllEmptyOrderFiles);
    };
}

export function addEmptyOrderFile(request) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, ADD_EMPTY_ORDER_FILE, EmptyOrderFilesEffect.putEmptyOrderFile, request);
    };
}

export function getUserSpecificEmptyOrderFiles(orderId) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, GET_EMPTY_ORDER_FILES, EmptyOrderFilesEffect.getUsersEmptyOrderFiles, orderId);
    };
}

export function removeEmptyOrderFile(request) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REMOVE_EMPTY_ORDER_FILE, EmptyOrderFilesEffect.deleteEmptyOrderFiles, request);
    };
}